/**
 * @generated SignedSource<<f1955ee4bbb4ec3a67b8f570ca90f071>>
 * @relayHash 96f6206ed3a62bf43b30d170fbe260bf
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 96f6206ed3a62bf43b30d170fbe260bf

import { ConcreteRequest } from 'relay-runtime';
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type SetChatAutoTranslationSettingInput = {
  appointmentId: string;
  isLiveTranslationEnabled: boolean;
  targetAgentLanguage: Language;
};
export type useSetChatAutoTranslationSettingMutation$variables = {
  input: SetChatAutoTranslationSettingInput;
};
export type useSetChatAutoTranslationSettingMutation$data = {
  readonly setChatAutoTranslationSetting: {
    readonly appointment: {
      readonly chat: {
        readonly autoTranslationSetting: {
          readonly isLiveTranslationEnabled: boolean;
          readonly targetAgentLanguage: Language;
        } | null;
      } | null;
      readonly id: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type useSetChatAutoTranslationSettingMutation = {
  response: useSetChatAutoTranslationSettingMutation$data;
  variables: useSetChatAutoTranslationSettingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Appointment",
  "kind": "LinkedField",
  "name": "appointment",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AppointmentChatType",
      "kind": "LinkedField",
      "name": "chat",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ChatAutoTranslationSettingType",
          "kind": "LinkedField",
          "name": "autoTranslationSetting",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isLiveTranslationEnabled",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "targetAgentLanguage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSetChatAutoTranslationSettingMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SetChatAutoTranslationSettingPayload",
        "kind": "LinkedField",
        "name": "setChatAutoTranslationSetting",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useSetChatAutoTranslationSettingMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SetChatAutoTranslationSettingPayload",
        "kind": "LinkedField",
        "name": "setChatAutoTranslationSetting",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "96f6206ed3a62bf43b30d170fbe260bf",
    "metadata": {},
    "name": "useSetChatAutoTranslationSettingMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "18bc33272492e0af001ec81e40561d76";

export default node;
